import { TwinConfiguratorNanoID } from './twinsTypes';

const basePath = '/twins';

export class TwinPath {
  static index() {
    return basePath;
  }

  static create(companyId?: string) {
    return companyId
      ? `${basePath}/new?companyId=${companyId}`
      : `${basePath}/new`;
  }

  static workspace(nanoId: TwinConfiguratorNanoID) {
    return `${basePath}/${nanoId}`;
  }

  static legacyWorkspace(nanoId: TwinConfiguratorNanoID) {
    return `${basePath}/${nanoId}/legacy`;
  }

  static assets() {
    return `${basePath}/assets`;
  }

  static materials() {
    return `${basePath}/materials`;
  }

  static parts() {
    return `${basePath}/parts`;
  }

  static rules() {
    return `${basePath}/rules`;
  }

  // Simplified screens, offered alongside the admin ones rather than replacing
  // them: same data, fewer controls. Kept on their own routes so which
  // audience gets which screen stays an open decision.
  static simpleIndex() {
    return `${basePath}/simple`;
  }

  static simpleConfigurator(nanoId: TwinConfiguratorNanoID) {
    return `${basePath}/simple/${nanoId}`;
  }

  static simpleLibrary() {
    return `${basePath}/simple/library`;
  }
}
